export const LISTINGS_PER_PAGE_NUMBER = 1000;
export const CALL_WAITING_TIME = 60000;
export const OPERATOR_WAITING_TIME_WHEN_TABLET_CALL = 20000;
export const DEFAULT_CHECK_IN_TIME = 15;
export const DEFAULT_CHECK_OUT_TIME = 10;